import * as fromDatatype from '../../../../models/datatype-library';

export class EntityOutstandingDocumentDtoModel {
    generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_guid: fromDatatype.GuidDataFieldInterface;
    customer_code: fromDatatype.VarcharDatatypeInterface;
    supplier_code: fromDatatype.VarcharDatatypeInterface;
    employee_code: fromDatatype.VarcharDatatypeInterface;
    merchant_code: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    server_doc_type: fromDatatype.VarcharDatatypeInterface;
    guid_comp: fromDatatype.GuidDataFieldInterface;
    comp_name: fromDatatype.VarcharDatatypeInterface;
    age: fromDatatype.IntegerDatatypeInterface;
    ccy_code: fromDatatype.VarcharDatatypeInterface;
    arap_doc_open: fromDatatype.NumericDatatypeInterface;
    arap_contra: fromDatatype.NumericDatatypeInterface;
    arap_bal: fromDatatype.NumericDatatypeInterface;
}